module.exports = __webpack_public_path__ + "img/readtopickup.7730fccf.svg";